import React, { useState, useEffect } from 'react';
import NumberFormat from 'react-number-format';
import queryString from 'query-string';
import Select from 'react-select';

import { history } from '../../../../_helpers/history'

function SearchGroupComponent({ location, handleClear, handleSearch }) {
  const queryParams = queryString.parse(location.search);

  const [status, setStatus] = useState(queryParams.status || '');
  const [firstName, setFirstName] = useState(queryParams.firstName || '');
  const [lastName, setLastName] = useState(queryParams.lastName || '');
  const [dateOfBirth, setDateOfBirth] = useState(queryParams.dateOfBirth || '');

  const statusOptions = [
    { value: "pending", label: "Pending" },
    { value: "scheduled", label: "Scheduled" },
    { value: "waitlist", label: "Waitlist" },
    { value: "removed", label: "Removed" },
    { value: "rejected", label: "Rejected" }
  ];

  const selectedStatus = statusOptions.find((selected) => {
    return selected.value === status;
  });

  useEffect(() => {
    const queryParams = queryString.parse(location.search);

    setStatus(queryParams.status || '');
    setFirstName(queryParams.firstName || '');
    setLastName(queryParams.lastName || '');
    setDateOfBirth(queryParams.dateOfBirth || '');
  }, [location.search]);

  return <>
    <div className="col">
      <Select
        value={selectedStatus || ''}
        placeholder='By Status'
        isClearable={true}
        options={statusOptions}
        onChange={(selected) => {
          if (selected) {
            setStatus(selected.value);
          }
          else {
            setStatus('');
          }
        }}
      />
    </div>
    <div className="col">
      <input onChange={e => setFirstName(e.target.value)}
        onKeyPress={e => {
          if (e.key === 'Enter') {
            handleSearch({ status, firstName, lastName, dateOfBirth });
          }
        }}
        value={firstName}
        type="text" className="form-control" placeholder="First Name" />
    </div>
    <div className="col">
      <input onChange={e => setLastName(e.target.value)}
        onKeyPress={e => {
          if (e.key === 'Enter') {
            handleSearch({ status, firstName, lastName, dateOfBirth });
          }
        }}
        value={lastName}
        type="text" className="form-control" placeholder="Last Name" />
    </div>
    <div className="col">
      <NumberFormat
        onValueChange={(e) => setDateOfBirth(e.formattedValue)}
        onKeyPress={e => {
          if (e.key === 'Enter') {
            handleSearch({ status, firstName, lastName, dateOfBirth });
          }
        }}
        value={dateOfBirth}
        format="##/##/####"
        mask="_"
        name="dateOfBirth"
        placeholder="Date of Birth"
        className="form-control"
      />
    </div>

    <div className="col">
      <button onClick={() => {
        handleSearch({ status, firstName, lastName, dateOfBirth });
      }} type="button" className="btn btn-primary mr-2">Search</button>
      <button onClick={() => {
        handleSearch({ status: "", firstName: "", lastName: "", dateOfBirth: "" });
        history.push(history.location.pathname);
      }} type="button" className="btn btn-outline-primary">Clear</button>
    </div>
  </>
}

export default SearchGroupComponent;